// extracted by mini-css-extract-plugin
export var coingeckoBadge = "ix_8B9Yu9Qv5Ij7rIsiw";
export var coingeckoBadgeLink = "o__LmdG3AolTfTivFLOg";